import React from 'react';
import PropTypes from 'prop-types';
import './input.scss';

const InputText = props => (
  <div>
    <input
      type="text"
      name={props.name}
      value={props.value}
      className="input"
      maxLength={props.maxLength}
      placeholder={props.placeholder}
      onChange={props.changeState}
    />
    {props.error && <label className="label-error">{props.errorMsg}</label>}
  </div>
);

InputText.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  errorMsg: PropTypes.string,
  maxLength: PropTypes.number,
  changeState: PropTypes.func,
};

export default InputText;
